import { passwordStrength } from "./PasswordPolicy";

const STRENGTH_LABEL = ["", "Weak", "Fair", "Good", "Excellent"];

/** Four-bar meter with a word for how strong the password is. */
export function PasswordStrength({ password }: { password: string }): React.JSX.Element {
  const level = passwordStrength(password);
  return (
    <div className="nb-stack-sm" aria-live="polite">
      <div className="nb-meter" data-level={level} aria-hidden="true">
        <i />
        <i />
        <i />
        <i />
      </div>
      <span className="nb-help">
        {level === 0 ? "Use a long phrase: it's easier to remember and more secure." : `Strength: ${STRENGTH_LABEL[level]}`}
      </span>
    </div>
  );
}
